






































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import PageHeader from '@/views/browse-and-go/components/PageHeader.vue'
import ContentComposer from '@/views/browse-and-go/components/ContentComposer.vue'
import { CARD_TYPE_DETAIL, CARD_TYPE_LABEL, CARD_TYPES, cloneData, formatDuration } from '@/services/browse-and-go/labels'
import { bngState, deleteCard, findCard, findOperation, saveCard } from '@/services/browse-and-go/store'
import { CardType, MultiChoiceCardModel } from '@/services/browse-and-go/types'

function blankCard(operationId = ''): MultiChoiceCardModel {
  return {
    id: '',
    operationModelId: operationId,
    name: '',
    type: 'MIXED',
    visual: '',
    validityMonths: 12,
    urssafEventIds: operationId ? [operationId] : [],
    itemIds: [],
    defaultActive: false,
    builtin: false
  }
}

@Component({
  name: 'BrowseAndGoCardEdit',
  components: { PageHeader, ContentComposer }
})
export default class extends Vue {
  private draft: MultiChoiceCardModel = blankCard()
  private ready = false
  private cardTypes = CARD_TYPES

  get isCreate() {
    return this.$route.name === 'BrowseAndGoCardCreate'
  }

  get canDelete() {
    return !this.isCreate && !this.draft.builtin
  }

  get operations() {
    return bngState.operations
  }

  get urssafOperations() {
    return bngState.operations.filter(operation => operation.family === 'URSSAF')
  }

  get merchants() {
    return bngState.merchants
  }

  get categories() {
    return bngState.categories
  }

  get selections() {
    return bngState.selections
  }

  get operationIsUrssaf() {
    const operation = findOperation(this.draft.operationModelId)
    return Boolean(operation && operation.family === 'URSSAF')
  }

  get durationLabel() {
    return formatDuration(this.draft.validityMonths || 0)
  }

  private typeLabel(type: CardType) {
    return CARD_TYPE_LABEL[type]
  }

  get typeDetail() {
    return this.draft ? CARD_TYPE_DETAIL[this.draft.type] : ''
  }

  @Watch('$route.fullPath', { immediate: true })
  private load() {
    const queryOperationId = typeof this.$route.query.operationId === 'string' ? this.$route.query.operationId : ''
    const cloneFrom = typeof this.$route.query.cloneFrom === 'string' ? this.$route.query.cloneFrom : ''

    if (!this.isCreate) {
      const card = findCard(String(this.$route.params.id || ''))
      if (!card) {
        this.$message.error('Modèle de carte multi-choix introuvable')
        this.$router.replace({ name: 'BrowseAndGoCards' })
        return
      }
      this.draft = cloneData(card)
      this.ready = true
      return
    }

    if (cloneFrom) {
      const source = findCard(cloneFrom)
      if (!source) {
        this.$message.error('Modèle à cloner introuvable')
        this.$router.replace({ name: 'BrowseAndGoCards' })
        return
      }
      this.draft = cloneData(source)
      this.draft.id = ''
      this.draft.builtin = false
      this.draft.name = `${source.name} — copie`
      this.ready = true
      return
    }

    this.draft = blankCard(queryOperationId)
    this.ready = true
  }

  private onOperationChange(id: string) {
    const operation = findOperation(id)
    if (!operation || operation.family !== 'URSSAF') {
      this.draft.urssafEventIds = []
      return
    }
    if (!this.draft.urssafEventIds.length) this.draft.urssafEventIds = [operation.id]
  }

  private onAddIds(ids: string[]) {
    this.draft.itemIds = Array.from(new Set([...this.draft.itemIds, ...ids]))
  }

  private onRemove(id: string) {
    this.draft.itemIds = this.draft.itemIds.filter(item => item !== id)
  }

  private onClear() {
    this.draft.itemIds = []
  }

  private returnLocation() {
    const from = this.$route.query.from
    if (from === 'urssaf') return { name: 'BrowseAndGoUrssaf' }
    if (from === 'other') return { name: 'BrowseAndGoOther' }
    return { name: 'BrowseAndGoCards' }
  }

  private cancel() {
    this.$router.push(this.returnLocation())
  }

  private save() {
    this.draft.name = this.draft.name.trim()
    this.draft.visual = this.draft.visual.trim()
    if (!this.draft.name) {
      this.$message.error('Le nom est obligatoire')
      return
    }
    if (!this.draft.visual) {
      this.$message.error('Le visuel est obligatoire')
      return
    }
    if (!this.draft.operationModelId) {
      this.$message.error('Le modèle d\'opération de rattachement est obligatoire')
      return
    }
    saveCard(this.draft)
    this.$message.success('Modèle de carte multi-choix enregistré')
    this.$router.push(this.returnLocation())
  }

  private remove() {
    this.$confirm('Supprimer ce modèle de carte multi-choix ?', 'Supprimer', {
      type: 'warning',
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler'
    }).then(() => {
      deleteCard(this.draft.id)
      this.$message.success('Modèle de carte multi-choix supprimé')
      this.$router.push({ name: 'BrowseAndGoCards' })
    }).catch(() => undefined)
  }
}
